@if (contentLoaded) {
  <div class="space-timeline">
    @if (activitiesDates.length > 0) {
      @for (date of activitiesDates; track date; let last = $last) {
        <app-timeline-date-box
          [time]="date"
          [actions]="activitiesMap[date]"
          [nextActionDate]="last ? meta.next_action_date : null"
          [actionsLoading]="actionsLoading"
          (loadMore)="loadMore()"
        >
        </app-timeline-date-box>
      }
    } @else {
      <p class="empty-message muted-text">ここに生徒のアクティビティが表示されます。</p>
    }
  </div>
} @else {
  <div class="spen-mod-flex-loading">
    <div class="loading-icon"></div>
  </div>
}
